import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

import { icons } from './assets/icons'

import { Provider } from 'react-redux'
import store from './store'
import { LabelProvider } from "./views/payroll/viewrunpayroll/_Components/LabelDataContext";

React.icons = icons

ReactDOM.render(
  <Provider store={store}>
    <LabelProvider>
    <App/>
    </LabelProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
